import * as styles from './index.module.scss';
import { Collapse, CollapseProps, Flex, Image } from 'antd';
import { FC, ReactNode } from 'react';
import { config } from '../../../../../config';

interface IProps {
  jobData?: {
    text: string;
    photoFiles: string[];
  }[];
  expandIcon: (panelProps: any) => ReactNode;
}

const ReferenceBlock: FC<IProps> = ({ jobData, expandIcon }) => {
  const collapseItems: CollapseProps['items'] = [
    {
      key: '1',
      label: 'РЕФЕРЕНС',
      children: (
        <Flex vertical gap={8}>
          <Flex align="center" gap={4}>
            {jobData?.[0]?.photoFiles?.map((file, index) => (
              <Image
                key={index}
                className={styles.img}
                width={80}
                src={`${config.EXTERNAL_ADDRESS}/public/${file}`}
              />
            ))}
          </Flex>

          {jobData?.[0].text && <div className={styles.description}>{jobData[0].text}</div>}
        </Flex>
      ),
    },
  ];

  return (
    <Collapse
      items={collapseItems}
      expandIcon={expandIcon}
      expandIconPosition="right"
      bordered={false}
      defaultActiveKey={[1]}
      ghost
    />
  );
};

export default ReferenceBlock;
